import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import ROUTES_ENUMS from 'routes/url.enum';

// const baseURL = 'http://localhost:3001/api/customer/';
const baseURL = 'https://api.rltourism.com/api/customer/';

export const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
}); 

// Request interceptor
axiosInstance.interceptors.request.use(
  (req) => {
    const LOGIN_USER_ACCESS_TOKEN = secureLocalStorage.getItem('token');
    if (LOGIN_USER_ACCESS_TOKEN) {
      req.headers.Authorization = LOGIN_USER_ACCESS_TOKEN;
    }
    return req;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Handle specific error status codes
      switch (error.response.status) {
        case 401:
          // Clear local storage and redirect to login page
          secureLocalStorage.clear();
          window.location.href = ROUTES_ENUMS.HOME; // Redirect to login page
          break;
        case 404:
          // Handle not found
          break;
        case 500:
          // Handle server error
          break;
        default:
        // Handle other errors
      }
    }
    return Promise.reject(error);
  }
);